// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3zt4t","upload":"Small_upload__Wfe9g","imageWrap":"Small_imageWrap__TtPYK","removeBtn":"Small_removeBtn__2JuVY"};